import type { Theme } from '@emotion/react';
import { useTheme, css } from '@emotion/react';
import { Stack, Text } from '@resi-media/resi-ui';
import { usePrefix } from '@studio/hooks/use-prefix';
import { NotFoundIcon } from '../NotFoundIcon';

const S = {
  container: () =>
    css({
      display: 'flex',
      flexFlow: 'column nowrap',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    }),
  stack: (theme: Theme) =>
    css({
      width: '100%',
      [theme.mq.md]: {
        width: '390px',
      },
    }),
};

type _Props = React.ComponentPropsWithoutRef<'section'>;

const NotFoundSection = (props: _Props) => {
  const theme = useTheme();
  const { prefixNS } = usePrefix('components:', 'notFound');

  return (
    <section css={S.container} {...props}>
      <Stack css={S.stack} dataTestId="not-found-section" p="m" textAlign="center">
        <NotFoundIcon fontSize={theme.typography.pxToRem(85)} />
        <Text
          colorVariant="heading"
          css={(theme) =>
            css({
              fontFamily: theme.typography.fontFamilyBody,
            })
          }
          variant="h4"
          weightVariant="semiBold"
        >
          {prefixNS('header')}
        </Text>
        <Text>{prefixNS('subHeader')} </Text>
      </Stack>
    </section>
  );
};

export { NotFoundSection };
